const languageList = () => import('@/pages/language/index.vue');
const languageForm = () => import('@/pages/language/form.vue');

export default [{
    path: '/language/list',
    component: languageList,
    meta: [{
        name: '语言管理'
    },
    {
        name: '语言列表',
        activeRoute: '/language/list'
    }]
}, {
    path: '/language/form',
    component: languageForm,
    meta: [{
        name: '语言管理'
    },
    {
        name: '语言列表',
        url: '/language/list',
    },
    {
        name: '添加/编辑',
        activeRoute: '/language/list'
    }]
}];